import React = require('react');
import { Tooltip } from '@tableau/widgets';

import { imgPath } from '~src/commonInfra/utils/ImgUrl';

import { tooltipButtonStyle, tooltipStyle } from './ExtensionsSectionStyle';

export interface TooltipProps {
  testId: string;
  content: string;
  // Accessible name for the tooltip trigger button. Defaults to the tooltip
  // content so the button always has a programmatic name (WCAG 4.1.2).
  label?: string;
}

export function QuickTooltip(props: TooltipProps) {
  // The trigger is a real <button> so assistive technology exposes the button
  // role and it is keyboard operable (WCAG 4.1.2). The icon is decorative
  // (alt='') because the button's aria-label carries the accessible name.
  // when tooltip plumbs through testId, delete this comment and data-tb-test-id applied to the button tag below
  return <Tooltip
    testId={props.testId}
    getContent={ () => {
      return <span>{props.content}</span>;
    }}>
    <button type={'button'} data-tb-test-id={props.testId} className={tooltipButtonStyle} aria-label={props.label || props.content}>
      <img className={tooltipStyle} src={imgPath('info_14px_small.svg')} alt={''}/>
    </button>
  </Tooltip>;
}
